import React from "react";
import { makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    minHeight: 500,
    "& .MuiDataGrid-columnHeaderWrapper": {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
    },
    "& .MuiDataGrid-columnHeaderWrapper .MuiIconButton-label svg": { color: "rgba(255,255,255,1)" },
  },
  cardMain: {
    marginBottom: "0px",
    paddingTop: "2px",
    width: "calc(100%)",
  },
  pageHeading: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightRegular,
    color: "#000",
  },
  tree: {
    flexGrow: 1,
    maxWidth: 400,
  },
  treeItem: {
    "& .MuiTreeItem-label": { padding: "10px" },
  },
  tab: {
    flexGrow: 1,
    display: "flex",
    height: 5000,
    marginTop: "20px",
  },
  list: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  listItem: { "& .MuiListItemIcon-root": { minWidth: "0px" } },
  rolesLeftSection: {
    "& .subHeading": { fontWeight: "bold" },
    borderRight: "1px solid grey",
    padding: "20px",
  },
  rolesRightSection: { "& .subHeading": { fontWeight: "bold" }, padding: "20px" },
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
    color: "#fff",
  },
}));
